import type { Transition } from "@uirouter/core";

import { swSettings } from "app/common/services/swSettings";
import { setActivationPageViewContext } from "app/pages/activation/helpers/activationPageViewContext";
import { createActivationApi } from "app/pages/activation/services/api";

import { ACTIVATION_HOME_ROUTE, DEFAULT_ACTIVATION_GRANULARITY } from "../constants";

import { isParamsInvalid } from "./isParamsInvalid";

// This hook swap invalid URL params and put correct one

export const onRedirectToActivation = () => {
    return async (transition: Transition) => {
        const toParams = transition.params("to");

        if (!toParams?.key) {
            return transition.router.stateService.target(ACTIVATION_HOME_ROUTE);
        }

        const api = createActivationApi();

        try {
            const activationSet = await api.activation.getActivationById(toParams.key);

            if (!activationSet) {
                return transition.router.stateService.target(ACTIVATION_HOME_ROUTE);
            }

            const validId = activationSet?.id;
            const validCountry = activationSet?.country;
            const isAssetOwner = !activationSet.sharedBy;

            setActivationPageViewContext(validId, { isAssetOwner });

            if (
                isParamsInvalid(
                    {
                        key: toParams?.key,
                        country: toParams?.country,
                        timeGranularity: toParams?.timeGranularity,
                        webSource: toParams?.webSource,
                    },
                    validId,
                    swSettings.components.Activation.totalCountries,
                )
            ) {
                const key = validId;
                const webSource = swSettings.components?.Activation?.resources?.DefaultSource;
                const country = validCountry;
                const timeGranularity = DEFAULT_ACTIVATION_GRANULARITY;

                const params = {
                    key,
                    country,
                    timeGranularity,
                    webSource,
                };

                return {
                    params,
                };
            }

            return;
        } catch {
            return transition.router.stateService.target(ACTIVATION_HOME_ROUTE);
        }
    };
};
